import { useSourceType } from '@/components/ConnectApps/Common/hooks/useSourceType';
import { usePublicSourceIntegrationMutation } from '@/components/ConnectApps/Common/publicSourceMutations';

export const useFollowPublicSource = () => {
  const { isWebsite, isNeedlWeb, isConnectPage, isCustomFeed } =
    useSourceType();
  return usePublicSourceIntegrationMutation({
    isWebsite,
    isNeedlWeb,
    isConnectPage,
    isCustomFeed,
  });
};
